import * as React from 'react';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Info, Warning, CheckCircle, Error } from '@mui/icons-material';
import { useTheme, Button, Typography, TextField, InputAdornment, FormControl,IconButton, Select, MenuItem, InputLabel } from "@mui/material";
import axios from 'axios';
import './InventoryReport.css';
import { tokens } from "../../theme";
import { Search, Refresh  } from '@mui/icons-material';
import env from "react-dotenv";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit'; // Import the Edit icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CustomSelect from '../../utils/CustomSelect'; // Import the CustomSelect component

const ProductVendorDataGrid = () => {
  const [rows, setRows] = useState([]);
  const [expandedVendorRows, setExpandedVendorRows] = useState({});
  const [searchTerm, setSearchTerm] = useState("");  // State for search term
  
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedInventoryStatus, setSelectedInventoryStatus] = useState('');
  const [uniqueMaterials, setUniqueMaterials] = useState([]);
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [uniqueInventoryStatuses, setUniqueInventoryStatuses] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // New state for advanced filters
  const [editingVendor, setEditingVendor] = useState(null);
  const [newLeadTime, setNewLeadTime] = useState('');
  const [openModal, setOpenModal] = useState(false);

  // States to control dropdown opens separately
  const [openMaterialsDropdown, setOpenMaterialsDropdown] = useState(false);
  const [openCategoriesDropdown, setOpenCategoriesDropdown] = useState(false);

  const user = useSelector((state) => state.user);
  // const isAdmin = user?.role === 'Store Admin';
  const isAdmin = (user?.role === 'Admin' && user?.department?.includes('Store')) || 
                  (user?.role === 'Super Admin' && user?.department?.includes('Store'));

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (!location.key) {
      navigate("/");
    }
  }, [location]);

  useEffect(() => {
    fetchProductVendorData();
    fetchRawMaterials();
    fetchCategories();
    fetchInventoryStatuses(); // Fetch inventory statuses
  }, []);

  const fetchProductVendorData = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/product-vendor`)
      .then((response) => {
        const products = response.data;
        const formattedRows = [];

        if (Array.isArray(products) && products.length > 0) {
          products.forEach((product) => {
            const availableVendorCount = product.vendors ? product.vendors.length : 0;

            // map vendors and inject vendorId and productId
            const vendorsWithIds = (product.vendors || []).map((vendor) => ({
              vendor: vendor.vendor,
              leadTime: vendor.leadTime,
              backupTime: vendor.backupTime,
              totalLeadTime: vendor.totalLeadTime,
              minQuantity: vendor.minQuantity,
              maxQuantity: vendor.maxQuantity,
              vendorId: vendor.vendorId,    // Ensure vendorId is set correctly    // ensure vendor_id is present from backend response
              productId: product.productId   // attach related product id for usage
            }));

            formattedRows.push({
              id: product.productId,
              type: 'product',
              product: product.product,
              itemCategory: product.itemCategory,
              quantity: product.quantity,
              dailyConsumption: product.dailyConsumption,
              baseUOM: product.baseUOM,
              orderStatus: product.orderStatus,
              orderDetail: product.orderDetail,
              minVendor: product.minVendor,
              availableVendor: availableVendorCount,
              vendorStatus: product.vendorStatus,
              inventoryStatus: product.inventoryStatus,
              minQuantity: Math.max(
                ...(product.vendors ? product.vendors.map((vendor) => vendor.minQuantity) : [0])
              ),
              // vendors: product.vendors || [],
              vendors: vendorsWithIds
            });
          });
        }

        setRows(formattedRows);
        setFilteredRows(formattedRows);
        //setUniqueMaterials ([...new Set(formattedRows.map(row => row.product))]);
        //setUniqueCategories([...new Set(formattedRows.map(row => row.itemCategory))]);
        // setUniqueInventoryStatuses([...new Set(formattedRows.map(row => row.inventoryStatus))]);
      })
      .catch((error) => console.error('Error fetching data:', error));
  };
   const fetchRawMaterials = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/list`)
      .then((response) => {
        // const materials = response.data.map(item => item.product_name); // Adjust based on your API response structure
        // setUniqueMaterials(materials);
        // Assuming the response is an array of objects with a product_name property
      setUniqueMaterials(response.data); // Ensure this is an array of objects
      })
      .catch((error) => console.error('Error fetching raw materials:', error));
  };

  const fetchCategories = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/categories`)
      .then((response) => {
        // Filter out null or empty categories
        const categories = response.data
          .map(item => item.item_category)
          .filter(category => category !== null && category !== ""); // Exclude null and empty strings
        setUniqueCategories(categories);
      })
      .catch((error) => console.error('Error fetching categories:', error));
  };

  const fetchInventoryStatuses = () => {
  axios
    .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/product-vendor/inventory-status`)
    .then((response) => {
      const mappedStatuses = response.data
        .map(item => item.inventory_status)
        .filter(status => ['GREEN', 'RED', 'YELLOW'].includes(status)); // Include only 3 values

      setUniqueInventoryStatuses(mappedStatuses);
    })
    .catch((error) => console.error('Error fetching inventory statuses:', error));
};

  const toggleVendorDetails = (rowId) => {
    setExpandedVendorRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const renderInventoryStatus = (row) => {
    const { availableVendor, minQuantity, quantity } = row;

    if (availableVendor < 2) {
      return <Info style={{ color: '#f55313' }} />;
    } else if (minQuantity === quantity) {
      return <Warning style={{ color: '#ecd81f' }} />;
    } else if (minQuantity < quantity) {
      return <CheckCircle style={{ color: 'green' }} />;
    } else if (minQuantity > quantity) {
      return <Error style={{ color: 'red' }} />;
    } else {
      return <span>{row.inventoryStatus}</span>;
    }
  };

  const rowClassName = (row) => {
    if (row.inventoryStatus === 'RED' && !row.orderDetail) {
      return 'red-row-highlight';
    }
    return '';
  };

 // Function to map inventory status for display
 const getDisplayInventoryStatus = (status) => {
  switch (status) {
    case 'GREEN':
      return 'In Stock';
    case 'RED':
      return 'Out Of Stock';
    case 'YELLOW':
      return 'Equal Stock';
    default:
      return status; // Return the original status if it's neither GREEN nor RED nor YELLOW
  }
};

useEffect(() => {
  const filtered = rows.filter(row => {
    const matchesSearch = row.product.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesMaterial = selectedMaterials.length === 0 || selectedMaterials.includes(row.product);
    const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(row.itemCategory);
    const matchesInventoryStatus = !selectedInventoryStatus || row.inventoryStatus === selectedInventoryStatus;

    return matchesSearch && matchesMaterial && matchesCategory && matchesInventoryStatus;
  });
  setFilteredRows(filtered);
}, [searchTerm, selectedMaterials, selectedCategories, selectedInventoryStatus, rows]);

const sanitizeWorksheetName = (name) => {
    // Remove invalid characters and limit to 31 characters
    return name.replace(/[*?:"\\\/\[\]]/g, '') // Remove invalid characters
               .replace(/\s+/g, '') // Remove all whitespace
               .replace(/^'|'$/g, '') // Remove single quotes from start and end
               .substring(0, 31); // Limit to 31 characters
};

const handleExport = async () => {
  const workbook = new ExcelJS.Workbook();

  // Create the main inventory sheet
  const mainWorksheet = workbook.addWorksheet('Main Inventory');

  // Add header rows for the main inventory sheet
  const titleRow = mainWorksheet.addRow(['ARYAN EXPORTERS PVT. LTD.']);
  mainWorksheet.mergeCells(`A1:I1`); // Merge cells A1 to I1
  titleRow.alignment = { horizontal: 'center', vertical: 'middle' }; // Center alignment
  const mergedTitleCell = mainWorksheet.getCell('A1');
  mergedTitleCell.font = { bold: true, size: 14 }; // Set font for the merged cell

  const summaryRow = mainWorksheet.addRow([`Summary Of Main Inventory Data on ${new Date().toLocaleDateString()}`]);
  mainWorksheet.mergeCells(`A2:I2`); // Merge cells A2 to I2
  summaryRow.alignment = { horizontal: 'center', vertical: 'middle' }; // Center alignment
  const mergedSummaryCell = mainWorksheet.getCell('A2');
  mergedSummaryCell.font = { bold: true, size: 12 }; // Set font for the merged cell

  // Add headers for the main inventory sheet
  const headerRow = mainWorksheet.addRow(['S/N', 'Raw Material', 'Category', 'Quantity', 'Base UOM', 'Daily Consumption', 'Min Quantity', 'Inventory Status', 'Available Vendors']);
  headerRow.font = { bold: true }; // Bold headers

  // Add data rows to the main inventory sheet
  filteredRows.forEach((row, index) => {
      mainWorksheet.addRow([
          index + 1, // S/N
          row.product || '',
          row.itemCategory || '',
          row.quantity || '',
          row.baseUOM || '',
          row.dailyConsumption || '',
          row.minQuantity || '',
          row.inventoryStatus === 'GREEN' ? 'In Stock' : row.inventoryStatus === 'RED' ? 'Out Of Stock' : '',
          row.availableVendor || ''
      ]);
  });

  // Apply styles to the main inventory worksheet
  mainWorksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell) => {
          // Apply border to all cells, including empty ones
          cell.border = {
              top: { style: 'thin' },
              bottom: { style: 'thin' },
              left: { style: 'thin' },
              right: { style: 'thin' },
          };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
      });

      // Bold for header rows
      if (rowNumber <= 2) {
          row.font = { bold: true };
      }
  });

  // Set column widths for the main inventory sheet
  mainWorksheet.getColumn(1).width = 5;   // S/N
  mainWorksheet.getColumn(2).width = 30;  // Raw Material
  mainWorksheet.getColumn(3).width = 25;  // Category
  mainWorksheet.getColumn(4).width = 10;  // Quantity
  mainWorksheet.getColumn(5).width = 10;  // Base UOM
  mainWorksheet.getColumn(6).width = 18;  // Daily Consumption
  mainWorksheet.getColumn(7).width = 14;  // Min Quantity
  mainWorksheet.getColumn(8).width = 15;  // Inventory Status
  mainWorksheet.getColumn(9).width = 16;  // Available Vendors

// Create a new sheet for each product
const existingWorksheetNames = new Set();

filteredRows.forEach((row) => {
    const sanitizedProductName = sanitizeWorksheetName(row.product);
    let productWorksheetName = sanitizedProductName;

    // Check for duplicates and modify the name if necessary
    let counter = 1;
    while (existingWorksheetNames.has(productWorksheetName)) {
        productWorksheetName = `${sanitizedProductName}_${counter}`;
        counter++;
    }

    existingWorksheetNames.add(productWorksheetName);

    // console.log(`Creating worksheet: ${productWorksheetName}`);

    const productWorksheet = workbook.addWorksheet(productWorksheetName);

      // Add header rows for the product sheet
      const productTitleRow = productWorksheet.addRow(['ARYAN EXPORTERS PVT. LTD.']);
      productWorksheet.mergeCells(`A1:F1`); // Merge cells A1 to F1
      productTitleRow.alignment = { horizontal: 'center', vertical: 'middle' }; // Center alignment
      const productMergedTitleCell = productWorksheet.getCell('A1');
      productMergedTitleCell.font = { bold: true, size: 14 }; // Set font for the merged cell

      const productSummaryRow = productWorksheet.addRow([`Summary Of ${row.product} (Category: ${row.itemCategory}) (Quantity: ${row.quantity}) (Daily Consumption: ${row.dailyConsumption}) (Inventory Status: ${row.inventoryStatus === 'GREEN' ? 'In Stock' : row.inventoryStatus === 'RED' ? 'Out Of Stock' : ''}) on ${new Date().toLocaleDateString()}`]);
      productWorksheet.mergeCells(`A2:F2`); // Merge cells A2 to F2
      productSummaryRow.alignment = { horizontal: 'center', vertical: 'middle' }; // Center alignment
      const productMergedSummaryCell = productWorksheet.getCell('A2');
      productMergedSummaryCell.font = { bold: true, size: 12 }; // Set font for the merged cell

      // Add headers for the product sheet
      const productHeaderRow = productWorksheet.addRow(['S/N', 'Vendor Name', 'Lead Time', 'Backup Time', 'Total Lead Time', 'Min Quantity']);
      productHeaderRow.font = { bold: true }; // Bold headers

      // Add vendor data for the product
      row.vendors.forEach((vendor, index) => {
          productWorksheet.addRow([
              index + 1, // S/N
              vendor.vendor || '',
              vendor.leadTime || '',
              vendor.backupTime || '',
              vendor.totalLeadTime || '',
              vendor.minQuantity || ''
          ]);
      });

      // Apply styles to the product worksheet
      productWorksheet.eachRow((row) => {
          row.eachCell((cell) => {
              // Apply border to all cells, including empty ones
              cell.border = {
                  top: { style: 'thin' },
                  bottom: { style: 'thin' },
                  left: { style: 'thin' },
                  right: { style: 'thin' },
              };
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
          });
      });

      // Set column widths for the product sheet
      productWorksheet.getColumn(1).width = 8;   // S/N
      productWorksheet.getColumn(2).width = 60;  // Vendor Name
      productWorksheet.getColumn(3).width = 18;  // Lead Time
      productWorksheet.getColumn(4).width = 18;  // Backup Time
      productWorksheet.getColumn(5).width = 20;  // Total Lead Time
      productWorksheet.getColumn(6).width = 18;  // Min Quantity
  });

  // Save the workbook
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/octet-stream' });
  saveAs(blob, 'MainInventoryData.xlsx');
};

const clearFilters = () => {
  setSearchTerm("");
  setSelectedMaterials([]);
  setSelectedCategories([]);
  setSelectedInventoryStatus("");
  // Reset any other filters if necessary
};

const handleEditVendor = (vendor) => {
  // console.log('Selected Vendor for Editing:', vendor); // Log the vendor object
  setEditingVendor({
    ...vendor,
    vendorId: vendor.vendorId // Ensure vendorId is included
  });
  setNewLeadTime(vendor.leadTime); // Pre-fill the input with the current lead time
  setOpenModal(true); // Open the modal
};

const handleCloseModal = () => {
  setOpenModal(false);
  setEditingVendor(null); // Clear the editing state
};

const saveLeadTime = async () => {
  if (editingVendor) {
    // console.log('Editing Vendor:', editingVendor); // Log the editingVendor object
    const payload = {
      product_id: editingVendor.productId,
      vendor_id: editingVendor.vendorId, // This should now be set correctly
      lead_time: Number(newLeadTime),
    };
    // console.log('Payload for API Call:', payload); // Log the payload
    try {
      await axios.put(`${process.env.REACT_APP_PJCBACKEND_URL}/api/product-vendor/edit-lead-time`, payload);
      fetchProductVendorData();
      handleCloseModal(); // Close the modal after saving
    } catch (error) {
      console.error('Error updating lead time:', error.response.data); // Log the error response for debugging
    }
  }
};

  return (
    <Box sx={{
      height: 500,
      width: '95%',
      marginLeft:"180px",
      paddingRight:"90px",
      marginTop:"0px"
    }} m={2}>
      {/* Inventory Heading and Search Box */}
      <Box
        sx={{
          marginTop: "5px",
          marginBottom: "10px",
          display: "flex",
          gap: "10px",
          alignItems: "center",
        }}
      >
              <TextField
          placeholder="Search"
          variant="outlined"
          size="small"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{
            // marginLeft: "10px",
            width: '1200px', // Set the desired width here
            backgroundColor: '#ffffff',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#00308F',
              },
              '&:hover fieldset': {
                borderColor: '#00207E',
              },
            },
          }}
        />

           {/* Filters */}
       {/* <Box display="flex" alignItems="center" mb={2}> */}
           {/* Advanced Filter Button */}
           <Button
           onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
           startIcon={<FilterListIcon />} // Add the filter icon here
         >
           Filter
         </Button>
 
           <Button 
           onClick={handleExport}
           startIcon={<SaveAltIcon />}
           >
             Export
           </Button>
 
           <IconButton
           onClick={() => window.location.reload()} // Refresh the page
           color="primary"
           sx={{
             backgroundColor: '#ffffff',
             '&:hover': {
               backgroundColor: '#f0f0f0',
             },
           }}
         >
           <Refresh />
         </IconButton>
       {/* </Box> */}
 
       </Box>
 
       {/* Advanced Filters */}
       {showAdvancedFilters && (
         <Box sx={{ marginTop: "15px", marginBottom: "10px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
 
 
         {/* Material Filter */}
         {/* <FormControl variant="outlined" size="small" sx={{ minWidth: 120, marginRight: 1, marginLeft: 1 }}>
                     <InputLabel>Raw Material</InputLabel>
                     <Select
                       multiple
                       value={selectedMaterials}
                       onChange={(e) => setSelectedMaterials(e.target.value)}
                       label="Raw Material"
                       renderValue={(selected) => selected.join(', ')}
                     >
                       {uniqueMaterials.map((material) => (
                         <MenuItem key={material} value={material}>
                           {material}
                         </MenuItem>
                       ))}
                     </Select>
                   </FormControl> */}
                  <CustomSelect
                    label="Raw Material"
                    value={selectedMaterials}
                    onChange={(e) => setSelectedMaterials(e.target.value)}
                    options={uniqueMaterials}
                    open={openMaterialsDropdown}
                    setOpen={setOpenMaterialsDropdown}
                    getOptionLabel={(option) => option.product_name} // Provide the function to extract the label
                  />  
         
         {/* <FormControl variant="outlined" size="small" sx={{ minWidth: 120, marginRight: 1 }}>
           <InputLabel>Category</InputLabel>
           <Select
             multiple
             value={selectedCategories}
             onChange={(e) => setSelectedCategories(e.target.value)}
             label="Category"
             renderValue={(selected) => selected.join(', ')}
           >
             {uniqueCategories.map((category) => (
               <MenuItem key={category} value={category}>
                 {category}
               </MenuItem>
             ))}
           </Select>
         </FormControl> */}

         {/* Category Filter */}
          <CustomSelect
            label="Category"
            value={selectedCategories}
            onChange={(e) => setSelectedCategories(e.target.value)}
            options={uniqueCategories}
            open={openCategoriesDropdown}
            setOpen={setOpenCategoriesDropdown}
            getOptionLabel={(option) => option} // If uniqueCategories is an array of strings
          />
 
         <FormControl variant="outlined" size="small" sx={{ minWidth: 120, marginRight: 2 }}>
           <InputLabel>Inventory Status</InputLabel>
           <Select
             value={selectedInventoryStatus}
             onChange={(e) => setSelectedInventoryStatus(e.target.value)}
             label="Inventory Status"
           >
             {uniqueInventoryStatuses.map((status) => (
               <MenuItem key={status} value={status}>
                 {getDisplayInventoryStatus(status)} {/* Use the mapping function here */}
               </MenuItem>
             ))}
           </Select>
         </FormControl>
 
         {/* Clear All Filters Button */}
        <Button
              onClick={clearFilters}
              // startIcon={<ClearIcon />} // Add the clear icon here
          >
            Clear Filter
        </Button>
          </Box>
        )}
      <TableContainer
        component={Paper}
        style={{
          maxHeight: '500px', // Set your desired height
          overflowY: 'auto', // Enable vertical scrolling
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Raw Material</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Category</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Quantity</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Base UOM</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Daily Consumption</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Vendors</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Min Quantity</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Inventory Status</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Min Vendor</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Available Vendors</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Vendor Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.map((row) => (
              <React.Fragment key={row.id}>
                <TableRow className={rowClassName(row)}>
                  <TableCell>{row.product}</TableCell>
                  <TableCell>{row.itemCategory}</TableCell>
                  <TableCell>{row.quantity}</TableCell>
                  <TableCell>{row.baseUOM}</TableCell>
                  <TableCell>{row.dailyConsumption}</TableCell>
                  <TableCell>
                    <Button
                      color="secondary"
                      size="small"
                      onClick={() => toggleVendorDetails(row.id)}
                    >
                      Vendor
                    </Button>
                  </TableCell>
                  <TableCell>{row.minQuantity}</TableCell>
                  <TableCell>{renderInventoryStatus(row)}</TableCell>
                  <TableCell>{row.minVendor}</TableCell>
                  <TableCell>{row.availableVendor}</TableCell>
                  <TableCell>{row.vendorStatus}</TableCell>
                </TableRow>
                {expandedVendorRows[row.id] && (
                  <TableRow>
                    <TableCell colSpan={11} style={{ padding: 0 }}>
                      <Box className="vendor-details-box">
                        <Table size="small" aria-label="vendor-details">
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={1} />
                              <TableCell style={{ fontWeight: 'bold' }}>
                                Vendor Name
                              </TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>Lead Time</TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>Backup Time</TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>
                                Total Lead Time
                              </TableCell>
                              <TableCell style={{ fontWeight: 'bold' }}>
                                Min Quantity
                              </TableCell>
                              {isAdmin && (
                              <TableCell style={{ fontWeight: 'bold' }}>
                                Edit
                              </TableCell>
                              )}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {row.vendors.map((vendor, index) => (
                              <TableRow key={`${row.id}-vendor-${index}`}>
                                <TableCell colSpan={1} />
                                <TableCell>{vendor.vendor}</TableCell>
                                <TableCell>{vendor.leadTime}</TableCell>
                                <TableCell>{vendor.backupTime}</TableCell>
                                <TableCell>{vendor.totalLeadTime}</TableCell>
                                <TableCell>{vendor.minQuantity}</TableCell>
                                {isAdmin && (
                                <TableCell>
                                  <IconButton onClick={() => handleEditVendor(vendor)}>
                                    <EditIcon />
                                  </IconButton>
                                </TableCell>
                                )}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>
          <Typography variant="h6" align="center" gutterBottom>
                    Edit
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            margin="dense"
            label="Lead Time"
            type="number"
            fullWidth
            variant="outlined"
            value={newLeadTime}
            onChange={(e) => setNewLeadTime(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button onClick={handleCloseModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={saveLeadTime} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default ProductVendorDataGrid;
